import vouchersTypes from '../../constants/vouchersTypes'
import auth_types from '../../constants/authTypes'
export * from './create'
export * from './delete'
export * from './get'
export * from './getindex'
export * from './publish'
export * from './update'
export * from './autofill'

const set_voucher_errors = (messages) => {
  return {
    type: vouchersTypes.set_errors,
    payload: messages
  }
}

const reset_voucher = () => {
  return {
    type: vouchersTypes.reset_voucher
  }
}

const clear_voucher = () => {
  return {
    type: vouchersTypes.clear_voucher
  }
}

const update_current_voucher = (response) => {
  return {
    type: auth_types.set_current_voucher,
    payload: response.data.voucher
  }
}

export {
  set_voucher_errors,
  reset_voucher,
  clear_voucher,
  update_current_voucher
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/index.js